import React, { useState } from 'react';
import { Globe } from 'lucide-react';
import { useLanguage } from '../../hooks';

export const LanguageSwitcher = () => {
  const { changeLanguage, getCurrentLanguage, availableLanguages } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const currentLang = getCurrentLanguage();

  const handleLanguageChange = (langCode) => {
    changeLanguage(langCode);
    setIsOpen(false);
  };

  const currentLanguage = availableLanguages.find(lang => lang.code === currentLang) || availableLanguages[0];

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="inline-flex items-center px-2.5 py-1.5 text-sm font-medium rounded-lg border border-white/30 bg-transparent text-white hover:bg-white/10 hover:border-white/40 transition-all duration-200"
      >
        <Globe className="w-3 h-3 mr-1.5" />
        <span className="mr-1">{currentLanguage.flag}</span>
        <span className="hidden sm:inline">{currentLanguage.name}</span>
      </button>

      {isOpen && (
        <>
          {/* 背景遮罩 */}
          <div 
            className="fixed inset-0 z-10" 
            onClick={() => setIsOpen(false)}
          />
          
          {/* 下拉菜单 */}
          <div className="absolute right-0 top-full mt-1 w-32 bg-white rounded-lg shadow-lg border border-slate-200 z-20">
            {availableLanguages.map((language) => (
              <button
                key={language.code}
                onClick={() => handleLanguageChange(language.code)}
                className={`w-full flex items-center px-3 py-2 text-sm hover:bg-slate-50 transition-colors duration-150 ${
                  language.code === currentLang 
                    ? 'bg-indigo-50 text-indigo-600 font-medium' 
                    : 'text-slate-700'
                } ${
                  language.code === availableLanguages[0].code ? 'rounded-t-lg' : ''
                } ${
                  language.code === availableLanguages[availableLanguages.length - 1].code ? 'rounded-b-lg' : ''
                }`}
              >
                <span className="mr-2">{language.flag}</span>
                <span>{language.name}</span>
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};